
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form6DataInfoType } from '@/types/Information/Form6';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form6Layout extends Vue {

    @Prop({required:true})
    result!: form6DataInfoType;
}

